import { render, staticRenderFns } from "./SupportImageUploader.vue?vue&type=template&id=4e59b7a5"
import script from "./SupportImageUploader.vue?vue&type=script&lang=js"
export * from "./SupportImageUploader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports